import { MultiStringFormCombobox } from "@/components/forms/FormCombobox";

interface MultiSelectProps {
  options: string[];
  placeholder?: string;
  addNewLabel?: string;
  onChange: (newVal: string[]) => unknown;
  value: string[];
  isErrored: boolean;
}

export default function MultiSelect(props: MultiSelectProps) {
  const { value, onChange, options, isErrored, placeholder } = props;

  return (
    <MultiStringFormCombobox
      id="demo-multiple-checkbox"
      options={options}
      value={value || []}
      onChange={onChange}
      isErrored={isErrored}
      placeholder={placeholder}
    />
  );
}
